<template>
     <div class="main">
            <div class="wrap">
                <!-- 头部 -->
                <div class="header">活动详情</div>
                    <!-- 视频 -->
                <div class="video_box">
                    <video :src="activitydetailshare.videoUrl" controls="controls">您的浏览器不支持 video 视屏播放。</video>
                </div>
                <!-- 内容 -->
                <div class="question">{{activitydetailshare.activityTitle}}</div>
                <!-- 发布的评论人 和时间 -->
                <div class="user_info userinfo">
                    <div class="userinfo_left">
                        <div class="user_img">
                            <img src="../../assets/img/default.png" alt="" v-if="activitydetailshare.headImg==''">
                            <img :src="activitydetailshare.headImg" alt="" v-else>
                        </div>
                        <div class="user_name_box">
                            <p class="user_name">{{activitydetailshare.nickName}}</p>
                        </div>
                    </div>
                    <div class="likebox">
                        <span>{{activitydetailshare.addTime}}发布</span>
                    </div>
                </div>
                <div class="activity_time">
                    <span class="activity_text">活动时间</span>
                    <span class="activity_number">{{activitydetailshare.startTime}} 至 {{activitydetailshare.endTime}}</span>
                </div>
                <!-- 所有的评论 -->
                <div class="comment">
                    <!-- 所有的评论的头部 -->
                    <div class="all_comments">所有评论({{activitydetailshare.commentNum}}条)</div>
                    <!-- 所有的评论列表 -->
                    <div class="all_comment_list" v-if="isdata==1">
                        <!-- 第一条评论 -->
                        <div class="all_comment_list_1"  v-for="(item,k) in activitycommentlist" :key="k">
                            <div>
                                <div class="user_img">
                                    <img src="../../assets/img/default.png" alt="" v-if="item.headImg==''">
                                     <img :src="item.headImg" alt="" v-else>
                                </div>
                            </div>
                            <div style="width: 100%;">
                                <div class="user_info">
                                    <div class="user_info_left">
                                        <div class="user_name_box">
                                            <p class="user_name">{{item.nickName}}</p>
                                        </div>
                                    </div>
                                    <div class="like_box">
                                        <span v-if="item.isPraise>0"><img src="../../assets/img/isprise.png" alt=""></span>
                                        <span v-else><img src="../../assets/img/prise.png" alt=""></span>
                                        <span class="prise_box_num">{{item.praiseNum}}</span>
                                    </div>           
                                </div>
                                <div class="all_comment_list_1_text">
                                    {{item.commentContent}}
                                </div>
                                <div class="all_comment_list_1_time">
                                    <span class="all_comment_list_1_time_report">{{item.addTime}} · 举报</span>
                                    <span class="all_comment_list_1_time_reply">回复</span>
                                </div>
                            </div>
                        </div>
                    </div>
                      <!-- 暂无数据 -->
                    <div v-else class="nodata">
                            <div>
                                暂无数据
                            </div>
                    </div>
                </div>
                <!-- 底部导航条-->
                <div class="bottom_wrap">
                    <div class="bottom">
                        <div class="bottom_con">
                            <div class="bottom_left">
                                <div class="share_img">
                                    <img src="../../assets/img/logo.png" alt="">
                                </div>
                                <div class="share_des">
                                    <p>线上掌柜</p>
                                    <p>新人注册有红包</p>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="bottom_right" @click="goDownload">
                                <div>立刻加入</div>
                            </div>
                            <div class="clear"></div>
                        </div>
                    </div>
                </div>
            </div>        
    </div>
</template>
<script>
import { Field,Toast} from 'vant';
import Vue from 'vue';
import { activitydetailModule } from "../../request/myFreecharge";
import { publicFun } from "@/tools/time.js"
Vue.use(Field);
export default {
    data(){
        return{
            activitydetailshare:{},
            activitycommentlist:[],
            isdata:2,
        }
    },
    created:async function(){
        await this.getactivitydetailshare()
        await this.getactivitycommentlistshare()
    },
    methods:{
        async getactivitydetailshare(){
            //  this.$route.query.activityID=25
            //  this.$route.query.usertoken=1630333978720
             await activitydetailModule.activitydetailshare(this.$route.query.activityID,this.$route.query.usertoken).then((response) => {
               switch(response.data.code){
                    case 100:
                         {
                         
                            this.activitydetailshare=response.data.result
                            this.activitydetailshare.startTime=publicFun.timestampToTime(Number(response.data.result.startTime))
                            this.activitydetailshare.addTime=publicFun.timestampToTime(Number(response.data.result.addTime))
                            this.activitydetailshare.endTime=publicFun.timestampToTime(Number(response.data.result.endTime))
                            
                            console.log(response.data.result)              
                         }
                        break;
                    case 101:
                        break;
                    case 102:
                        Toast.clear();
                        break;
                    case 100001:
                        break;
                }
            }).catch(()=>{})
        },
         async getactivitycommentlistshare(){
            //  this.$route.query.activityID=25
            //  this.$route.query.usertoken=123456789
             await activitydetailModule.activitycommentlistshare(1,10,1,this.$route.query.activityID,0,this.$route.query.usertoken).then((response) => {
               switch(response.data.code){
                    case 100:
                         {
                            this.isdata=1
                            this.activitycommentlist=response.data.result
                            console.log(response.data.result) 
                            this.activitycommentlist.forEach(e=>{
                                e.addTime=publicFun.dateDiff(Number(e.addTime))
                            })
                                         
                         }
                        break;
                    case 101:
                        this.isdata=2
                        break;
                    case 102:
                        Toast.clear();
                        break;
                    case 100001:
                        break;
                }
            }).catch(()=>{})
        },
        goDownload(){
            this.$router.push({
                path:'/download',
                query:{
                    marktype:1,
                }
            })
            
        },
        
    }
}
</script>
<style scoped>
.wrap{
    width: 87.2%;
    margin: 0 auto;
}
.header{
    font-size: 0.5rem;
    font-weight: bold;
    color: #323232;
    margin-left: 1.03rem;
    padding-top: 0.533rem;
}
/* 视频播放 */
.video_box{
    height: 4.33rem;
    display: flex;
    width: 100%;
    justify-content: center;
    padding-top: 1.02rem;
}
.video_box video{
    width: 8.72rem;
    max-height: 4.33rem;
}

.main{
    width: 100%;
}
.question{
    font-size: 0.4rem;
    padding-top: 0.267rem;
    line-height: 0.56rem;
    color: #323232;
    font-weight: bold;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
}
.user_info{
    width: 100%;
}
.user_img,.user_level_two_img,.user_name_box{
    float: left;
}
.user_img img{
    border-radius: 50%;
    width: 0.69rem;
    height: 0.69rem;
    object-fit: cover;
    vertical-align: middle;
}
.user_name_box{
    display: flex;
    margin-left: 0.26rem;
    align-items: center;
}
.user_name{
    color: #323232;
    font-size: 0.346rem;
    width: 4rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.like_box{
    float: right;
    font-size: 0.32rem;
    color: #909090;
    display: flex;
    align-items: center;
}
.activity_time{
    display: flex;
    flex-direction: column;
    margin-top:0.533rem;
    font-size: 0.373rem;
    color: #FF0000;
    font-weight: Medium;
    width: 7.6rem;
 
}

.all_comments{
    font-size: 0.426rem;
    font-weight: Bold;
    color: #323232;
    margin-top: 1.06rem;
}
.all_comment_list{
    margin-top: 0.4rem;
}
.all_comment_list_1 .user_info{
    display: flex;
    justify-content: space-between;
    align-content: center;
}
 .all_comment_list_1 .user_info_left{
    display: flex;
    align-content: center;
}
.all_comment_list_1{
    display: flex;
    padding: 0.433rem 0rem;
}
.all_comment_list  .all_comment_list_1  .user_info  .user_name_box  .user_name{
    font-size: 0.37rem;
    color: #8A0000;
    font-weight: Medium;
}
.all_comment_list  .all_comment_list_1  .user_info  .like_box  .prise_box_num{
    font-size:0.37rem;
    color:#323232;
    margin-left: 0.266rem;
}
.all_comment_list_1_text{
    font-size: 0.4rem;
    color: #323232;
    font-weight: Medium;
    padding: 0.497rem 0.64rem 0rem 0.26rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp:2;
    -webkit-box-orient: vertical;
    -webkit-box-orient: vertical;
}
.all_comment_list_1_time{
    margin-top: 0.42rem;
    display: flex;
    justify-content: space-between;
}
.all_comment_list_1_time_report{
    font-size: 0.32rem;
    color: #323232;
    font-weight: Medium;
    margin-left: 0.26rem;
}
.all_comment_list_1_time_reply{
    font-size: 0.32rem;
    color: #323232;
    font-weight: Medium;
}
.like_box img{
    width: 0.426rem;
    object-fit: cover;
}
.userinfo{
    margin-top: 0.433rem;
    align-items: center;
    display: flex;
    justify-content: space-between;
}
.userinfo_left{
    display: flex;
    align-items: center;
}
.likebox{
    color: #909090;
    font-size: 0.28rem;
}
.nodata{
    height: 3rem;
    display: flex;
    align-items: center;
    justify-content: space-around;
}
</style>